import { Box, Paper, Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => {
    return {
        paper: {
            background: "#3E4094",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
            color: "#fff",
            [theme.breakpoints.up('sm')]: {
                position: "relative",
            },
        },
        arrow: {
            position: "absolute",
            width: "20px",
            height: "20px",
            background: "#3E4094",
            top: "50%",
            right: "0px",
            transform: "rotate(45deg) translateY(-70%)",
            [theme.breakpoints.up('sm')]: {
                position: "absolute",
                width: "16px",
                height: "16px",
                right: "2px",
                transform: "rotate(45deg) translateY(-70%)"
            },
        }
    }
})

const StatusBox = ({ status, statusCount, arrow }) => {
    const { classes } = useStyles();
    return (
        <Paper elevation={0} className={classes.paper} sx={{ padding: { lg: "5px 20px", md: "5px 20px", xs: "10px 15px" }, }}>
            <Typography sx={{ fontSize: { lg: 18, md: 15, xs: 12 } }}>{status}</Typography>
            <Typography sx={{ fontSize: { lg: 38, md: 20, xs: 15 } }} fontWeight={"bold"}>{statusCount}</Typography>
            {arrow && <Box className={classes.arrow}></Box>}
        </Paper>
    )
}

export default StatusBox
